import { NgModule } from "@angular/core";
import {HttpModule} from '@angular/http';
import {RestDataSource} from './rest.datasource';
import {LangStaticDataSource} from './lang.data';
import {LangRepository} from './lang.repository';

@NgModule({
  imports: [HttpModule],
  providers: [RestDataSource, LangStaticDataSource, LangRepository]
})
export class ModelModule { }



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/model/model.module.ts